class CustomAccordion extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            accordion: '.custom-accordion',
            accordionTrigger: '.custom-accordion__trigger',
            accordionPanel: '.custom-accordion__panel',
            accordionContent: '.custom-accordion__content',
        };
        this.initAccordion();
    }

    connectedCallback() {
        this.querySelectorAll(this.selectors.accordion).forEach(el => {
            const trigger = el.querySelector(this.selectors.accordionTrigger);
            const panel = el.querySelector(this.selectors.accordionPanel);
            const content = el.querySelector(this.selectors.accordionContent);
            if (!trigger || !panel || !content) return;
            if (trigger.getAttribute('aria-expanded') === 'true') {
                panel.style.height = `${content.scrollHeight}px`;
            }
        });
    }

    initAccordion() {
        this.querySelectorAll(this.selectors.accordion).forEach(el => {
            const trigger = el.querySelector(this.selectors.accordionTrigger);
            if (!trigger) return;

            trigger.addEventListener('click', () => this.toggleAccordion(el, trigger));
        });
    }

    toggleAccordion(accordion, trigger) {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const panel = accordion.querySelector(this.selectors.accordionPanel);
        const content = accordion.querySelector(this.selectors.accordionContent);
        if (!panel || !content) return;

        trigger.setAttribute('aria-expanded', !isExpanded);

        if (!isExpanded) {
            const contentHeight = content.scrollHeight;
            panel.style.height = `${contentHeight}px`;
        } else {
            panel.style.height = '0';
        }
    }
}

customElements.define('custom-accordion', CustomAccordion);